import AppTab from '@/karehero-app/shell/AppTab';
import HomeScreen from '@/karehero-app/home/HomeScreen';
import { RECIPIENT } from '@/karehero-app/tell-us-once/intake/content';

/**
 * Home, where the intake ends.
 *
 * Straight into the app after the review rather than asking what they would
 * like to do next: the benefits calculator is a card on Home, so the question
 * answers itself by being there.
 */
const InAppHome = ({ onCalculator }: { onCalculator?: () => void }) => (
  <AppTab active='home'>
    <HomeScreen
      title={RECIPIENT}
      onCard={(title) => {
        if (title === 'Benefits calculator') onCalculator?.();
      }}
    />
  </AppTab>
);

export default InAppHome;
